export class AccordionItem extends HTMLElement {
  connectedCallback() {
    this.summary.addEventListener('click', () => {
      // Close other accordion items
      const allItems = document.querySelectorAll('accordion-item');
      allItems.forEach(item => {
        if (item !== this && item.isOpen) {
          item.close();
        }
      });

      // Toggle current accordion item
      this.isOpen ? this.close() : this.open();
    });

    if (this.isOpen) {
      this.open();
    }
  }

  open() {
    this.removeAttribute('closed');
    this.setAttribute('open', '');
    $(this.content).slideToggle(200);
  }

  close() {
    this.setAttribute('closed', '');
    this.removeAttribute('open');
    $(this.content).slideUp(200);
  }

  get isOpen() {
    return this.hasAttribute('open');
  }
  
  get summary() {
    return this.querySelector('[ref="summary"]');
  }
  get content() {
    return this.querySelector('[ref="content"]');
  }
}

if (!customElements.get('accordion-item')) {
  customElements.define('accordion-item', AccordionItem);
}